import { render, staticRenderFns } from "./SupportMenu.vue?vue&type=template&id=1410766e&scoped=true&"
import script from "./SupportMenu.vue?vue&type=script&lang=js&"
export * from "./SupportMenu.vue?vue&type=script&lang=js&"
import style0 from "./SupportMenu.vue?vue&type=style&index=0&id=1410766e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1410766e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1410766e')) {
      api.createRecord('1410766e', component.options)
    } else {
      api.reload('1410766e', component.options)
    }
    module.hot.accept("./SupportMenu.vue?vue&type=template&id=1410766e&scoped=true&", function () {
      api.rerender('1410766e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Extra/SupportMenu.vue"
export default component.exports